import { IS_MENU_OPEN } from "../type";

export const setStatusOfMenu = (bool) => (dispatch) => {
  dispatch({
    type: IS_MENU_OPEN,
    payload: bool
  });
};
